import api from '@/api'
import TitanRequest from '@/model/campaign/TitanRequest'
import TitanSearchRequest from '@/model/campaign/TitanSearchRequest'

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/titan/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllTitans(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/titan/get/all',
          TitanSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
    getTitanById({ commit }, id) {
      return api.base()
        .get('/titan/id/' + id)
        .then(
          response => {
            return response.data.data
          }
        )
    },

    createTitan({ commit }, { titan }) {
      return api.base()
        .post('/titan/add', TitanRequest(titan))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateTitan({ commit }, { titan, id }) {
      return api.base()
        .post('/titan/update/'+id, TitanRequest(titan))
        .then(
          response => {
            return response.data.data
          }
        )
    }
  },
}
